import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getCoachMemberSessionOffsets, putCoachMemberSessionOffsets } from './api';
import { coachMemberSessionOffsetKeys } from './keys';
import { PutCoachMemberSessionOffsetsBody } from './types';

export const useCoachMemberSessionOffsets = ({
    centerId,
    coachId,
    year,
    month,
    enabled = true,
}: {
    centerId: string;
    coachId: string;
    year: string;
    month: string;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: coachMemberSessionOffsetKeys.list(centerId, coachId, year, month),
        queryFn: () => getCoachMemberSessionOffsets({ centerId, coachId, year, month }),
        enabled: enabled && !!centerId && !!coachId,
        select: (data) => data?.data,
    });

export const usePutCoachMemberSessionOffsets = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({
            centerId,
            coachId,
            body,
        }: {
            centerId: string;
            coachId: string;
            body: PutCoachMemberSessionOffsetsBody;
        }) => putCoachMemberSessionOffsets({ centerId, coachId, body }),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: [...coachMemberSessionOffsetKeys.all, 'list', variables.centerId, variables.coachId],
            });
            // sessionTier 관련 하위 집계(정산/급여)도 무효화
            queryClient.invalidateQueries({ queryKey: ['getClassFeeSettlement'] });
            queryClient.invalidateQueries({ queryKey: ['getSalaryCalcsQuery'] });
            queryClient.invalidateQueries({ queryKey: ['getSalaryCalcQuery'] });
        },
    });
};
